var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmUploadBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.725 5.375C3.025 5.7 3.55 5.7 3.85 5.375L5.7 3.55V9.6C5.7 10.05 6.05 10.4 6.5 10.4C6.925 10.4 7.3 10.05 7.3 9.6V3.55L9.125 5.375C9.425 5.7 9.95 5.7 10.25 5.375C10.575 5.075 10.575 4.55 10.25 4.25L7.05 1.05C6.9 0.9 6.7 0.8 6.5 0.8C6.275 0.8 6.075 0.9 5.925 1.05L2.725 4.25C2.4 4.55 2.4 5.075 2.725 5.375ZM12.1 9.6H8.1C8.1 10.5 7.375 11.2 6.5 11.2C5.6 11.2 4.9 10.5 4.9 9.6H0.9C0.45 9.6 0.0999999 9.975 0.0999999 10.4V12.8C0.0999999 13.25 0.45 13.6 0.9 13.6H12.1C12.525 13.6 12.9 13.25 12.9 12.8V10.4C12.9 9.975 12.525 9.6 12.1 9.6ZM10.9 12.2C10.55 12.2 10.3 11.95 10.3 11.6C10.3 11.275 10.55 11 10.9 11C11.225 11 11.5 11.275 11.5 11.6C11.5 11.95 11.225 12.2 10.9 12.2Z",
    fill: "#141824"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmUploadBtn);
export default __webpack_public_path__ + "static/media/sm-upload-btn.c51d11543b7c2c54a7a214d3f5f7c8f5.svg";
export { ForwardRef as ReactComponent };